import type { ISbStories, ISbStoriesParams } from "storyblok-js-client"

import { getDimension, getLang } from "~/lib/i18n/utils/get-i18n"
import Storyblok from "~/lib/storyblok/client"
import type { SbAllowedFolderPath } from "~/lib/storyblok/constants"
import { getStoryblokCV } from "~/lib/storyblok/utils/fetch-cv"
import { logger } from "~/utils/logger"

export type StoriesOptions = Omit<ISbStoriesParams, "starts_with"> &
  Omit<ISbStoriesParams, "language"> & {
    locale: string
    starts_with?: SbAllowedFolderPath
  }

export async function fetchSbStories({ locale, starts_with, ...options }: StoriesOptions): Promise<ISbStories> {
  try {
    const dimension = getDimension(locale)
    const pathWithDimension = `${dimension}/${starts_with}`

    const cv = await getStoryblokCV()

    return await Storyblok.get(`cdn/stories`, {
      language: getLang(locale),
      starts_with: pathWithDimension,
      version: "published",
      ...options,
      ...(cv && { cv }),
    })
  } catch (error) {
    logger.warn(error)
    throw new Error(`Failed to fetch stories: ${JSON.stringify(error, null, 2)}`)
  }
}
